module.exports = __webpack_public_path__ + "static/InvestmentOptions-bf480f208d5ab32672ef68a7b9463e8f.png";